import { render, staticRenderFns } from "./App1Scope3.vue?vue&type=template&id=46cc6c8c&scoped=true&"
import script from "./App1Scope3.vue?vue&type=script&lang=js&"
export * from "./App1Scope3.vue?vue&type=script&lang=js&"
import style0 from "./App1Scope3.vue?vue&type=style&index=0&id=46cc6c8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc6c8c",
  null
  
)

export default component.exports